/**
 * @module cover-modes
 *
 * @author christian.sany@notch-interactive.com
 *
 * @description This module is to manage the different cover-mode instances
 */

/* Imports */
import coverMode from '../components/cover-mode';

const instance = {},
    coverModes = [];

/**
 * Add new coverMode
 *
 * @param {object} options of the coverMode
 * @return {number} index of the new instance
 */
instance.add = (options) => {
    return coverModes.push(coverMode(options)) - 1;
};

/**
 * Refresh coverModes
 *
 * @param {number} index of the coverMode to refresh, if no index is given, all will be refreshed
 */
instance.refresh = (index) => {
    if (index && typeof coverModes[index] !== 'undefined' && coverModes[index] !== null) {
        coverModes[index].refreshElements();
    } else {
        coverModes.forEach((coverMode) => {
            coverMode.refreshElements();
        });
    }
};

/**
 * Remove coverMode with given index
 *
 * @param {number} index of the coverMode to remove
 */
instance.remove = (index) => {

    // Check if index exists and covermode was not already destroyed
    if (typeof coverModes[index] !== 'undefined' && coverModes[index] !== null) {
        coverModes[index].destroy();
        coverModes.splice(index, 1);
    }
};

/**
 * Remove all coverModes
 */
instance.removeAll = () => {
    coverModes.forEach((value, index) => {
        instance.remove(index);
    });
};

/**
 * Initiate module with all cover modes
 */
instance.init = () => {
    instance.add({
        teaserImage: '.header-teaser img',
        referenceContainer: '.header-teaser',
        minWidth: 1024
    });

    instance.add({
        teaserImage: '.content-teaser img',
        referenceContainer: '.content-teaser__image'
    });

    instance.add({
        teaserImage: '.article-teaser img',
        referenceContainer: '.article-teaser__image'
    });

    instance.add({
        teaserImage: '.perslistview-item__avatar img',
        referenceContainer: '.perslistview-item__avatar'
    });

    instance.add({
        teaserImage: '.quickview-person__avatar img',
        referenceContainer: '.quickview-person__avatar'
    });

    instance.add({
        teaserImage: '.person-header__image img',
        referenceContainer: '.person-header__image',
        minWidth: 540
    });

    instance.add({
        teaserImage: '.person-tile__image img',
        referenceContainer: '.person-tile__image'
    });

    instance.add({
        teaserImage: '.m-teaser-live-ticker img',
        referenceContainer: '.m-teaser-live-ticker'
    });

    instance.add({
        teaserImage: '.author-info__image img',
        referenceContainer: '.author-info__image'
    });

    instance.add({
        teaserImage: '.category__inner img',
        referenceContainer: '.category__inner'
    });
};

/**
 * Destroy the module
 */
instance.destroy = () => {
    instance.removeAll();
};

export default instance;

// export forms object to window
window.DS = window.DS || {};
window.DS.coverModes = instance;
